import { TAreaUnitType } from '@cian/api-models/offer-card/v1/get-offer-data';

type textLandStatusListType = { [index in TAreaUnitType]?: string };

const text: textLandStatusListType = {
  hectare: 'га',
  sotka: 'сот.',
};

export function getLandAreaUnitTypeText(index: TAreaUnitType) {
  return text[index];
}
